import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const EmpresasView = lazy(() => import('../../container/ventas/empresas/Index'));
const EmpresasForm = lazy(() => import('../../container/ventas/empresas/Form'));

const EmpresasRoute = () => {
    const { path } = useRouteMatch();
    return (
        <Switch>
             <Route path= {`${path}/ventas/empresas/listado`} component = { EmpresasView } />
             <Route path={`${path}/ventas/empresas/agregar`} component = { EmpresasForm } />
             <Route exact path = {`${path}/ventas/empresas/editar/:id`} component = { EmpresasForm } />
            </Switch>
  );
};

export default EmpresasRoute;

